const NAMESPACE = "reflowBanner";

const KEYS = {
    bannerMessage2025: "bannerMessage2025",
    registerLinkText2025: "registerLinkText2025"
};

const MESSAGES = {
    [KEYS.bannerMessage2025]: {
        value: "{linkText} for the free PowerClerk conference: Reflow™ 2025, the online PowerClerk conference that's exclusively for utilities. Learn how your utility peers are solving business process & workflow automation challenges using PowerClerk.",
        comment: "Text of the Reflow promotion banner"
    },
    [KEYS.registerLinkText2025]: {
        value: "Register now",
        comment: "Link text for the register link within the reflow promo banner message"
    }
};

export { KEYS, NAMESPACE, MESSAGES };
